export default "__VITE_ASSET__OdLwOT9p__"